import React, { useState, useRef, useEffect } from 'react';
import './Header.css';

export const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const dropdownRef = useRef(null);
  const containerRef = useRef(null);
  const [hidden, setHidden] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);

  // Update header width for dropdown positioning
  useEffect(() => {
    if (dropdownRef.current && containerRef.current) {
      const headerWidth = containerRef.current.offsetWidth || 240;
      dropdownRef.current.style.setProperty('--header-width', `${headerWidth}px`);
    }
  }, [menuOpen]);

  // Scroll direction detection
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 50) {
        setHidden(true); // Scrolling down
      } else {
        setHidden(false); // Scrolling up
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  return (
    <div
      className={`header-container ${hidden ? 'hide-header' : ''}`}
      ref={containerRef}
    >
      <header className="site-header">
        <div className="header-content">
          <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            <span></span>
            <span></span>
            <span></span>
          </div>

          <div className="brand-name">PC Build Guru</div>

          <div className="profile-icon">
            <a href="/" aria-label="Home">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M12 3l9 8h-3v10h-12v-10h-3l9-8zm0-2l-11 10h3v12h16v-12h3l-11-10z" />
              </svg>
            </a>
          </div>

        </div>
      </header>

      <div
        className={`dropdown-menu ${menuOpen ? 'show' : ''}`}
        ref={dropdownRef}
      >
        <a href="/questionnaire">AI Builder</a>
        <a href="/compare">Compare Parts</a>
        <a href="/guide">Guides</a>
      </div>
    </div>
  );
};
